import React from 'react'

// @ts-ignore
import FormField, { FormLayout } from 'shared/newFormElements'

import { isRequired } from '../../../helpers'
import translate from '../../translate'

const handlePreventAction = (event) => {
  event.preventDefault()
}

const ClientReferencesInformation = ({ fields, selects, noVisibilityFilter }) => {
  return !!fields.ReferralID || !!fields.ReferralNote ? (
    <FormLayout
      visible={noVisibilityFilter || !!(fields.ReferralID || fields.ReferralNote)}
      label={translate('lbl_ref')}
    >
      {!!fields.ReferralID && (
        <FormField
          visible={noVisibilityFilter || !!fields.ReferralID}
          name="ReferralID"
          options={selects.Ref}
          required={isRequired(fields.ReferralID)}
          type="select"
          onBlur={handlePreventAction}
        />
      )}
      {!!fields.ReferralNote && (
        <FormField
          visible={noVisibilityFilter || !!fields.ReferralNote}
          name="ReferralNote"
          required={isRequired(fields.ReferralNote)}
          type="textarea"
          maxLength={fields.ReferralNote && fields.ReferralNote.MaxLen}
        />
      )}
    </FormLayout>
  ) : (
    <></>
  )
}

export default ClientReferencesInformation
